import React, { Component } from "react";
import { alertActions } from '../../action/AlertAction';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { loginActions } from "../../action/loginAction";
import { gameActions } from "../../action/GameAction";
import { history } from "../../helpers/history";
import Header from "../../Header/Header";
import { commonClass } from "../../helpers/commonClass";
import { appVariables } from "../../helpers/appVariables";
import { Helmet } from "react-helmet";
class MyFavouriteNew extends Component {
    constructor(props) {
        super(props);
        //only allow logged in users
        if (!props.user || props.user.mobileNo == "0") {
            history.push('/login');
        }
        this.state = {
            showdDeleteMsg: false,
            creditStatus: 0,
            creditStatus1: 0,
            creditStatus2: 0,
            creditStatus3: 0,
            creditStatus4: 0,
            creditStatus5: 0,
            allStatus: 0
        }
        this.showFavPop();
    }

    static getDerivedStateFromProps(props, state) {
        return {
            FavNo: props.FavNo
        }
    }

    PlayAgain = (gameNo, gameID) => {
        gameNo = gameID + '~' + gameNo;
        localStorage.setItem('setfavNo', gameNo);
        commonClass.IDPageControl(gameID)
        // if (gameID == 1) {
        //     history.push('/fortune6');
        // }
        // else if (gameID == 2) {
        //     history.push('/super6');
        // }
        // else if (gameID == 3) {
        //     history.push('/magic5');
        // }
        // else if (gameID == 5) {
        //     history.push('/dream5');
        // }
        // else if (gameID == 6) {
        //     history.push('/rush3');
        // }
        // else {
        //     history.push('/lucky1');
        // }
    }

    showMsg = (Msg) => {
        this.props.alertError(Msg);
    }
    componentDidMount() {
        //window.FavouritesPopUp();
        // localStorage.setItem('atabId', 7); this code is using in Account Component
    }
    componentDidUpdate() {
        if (this.props.ObjDeleteFavNo && this.props.ObjDeleteFavNo.Status_id == 0 && this.state.showdDeleteMsg == true) {
            this.state.showdDeleteMsg = false;
            this.props.GetfavNo(0, this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey);
        }
    }
    showFavPop = () => {
        this.props.GetfavNo(0, this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey);
    }
    DeletefavNo = (id, Obj) => {
        this.props.DeletefavNo(id, this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey);
        this.state.showdDeleteMsg = true;
        this.SendTracingCode(Obj)
    }

    SendTracingCode = (Obj) => {
        let uObj = {};
        Obj['gamegroupID'] = Obj.game_group_id;
        Obj['BetSelection'] = Obj.numbers.split(';');
        let amount = 0;
        switch (parseInt(Obj.game_group_id)) {
            case 1:
                amount = appVariables.PRIZE_STRUCT_FORTUNE5.BetAmount
                break;
            case 2:
                amount = appVariables.PRIZE_STRUCT_SUPER6.BetAmount
                break;
            case 3:
                amount = appVariables.PRIZE_STRUCT_MAGIC5.BetAmount
                break;
            case 4:
                amount = appVariables.PRIZE_STRUCT_LUCKY1.BetAmount
                break;
            case 5:
                amount = appVariables.PRIZE_STRUCT_DREAM5.BetAmount
                break;
            case 6:
                amount = appVariables.PRIZE_STRUCT_RUSH3.BetAmount
                break;
            default:
                break;
        }
        Obj['stakeValue'] = amount;
        let SavemyNo = [Obj]
        commonClass.SendEventTracking(13, uObj, false, SavemyNo);
    }

    chkbtnClick = (id) => {
        if (id == 1) {
            this.setState({ creditStatus: (this.state.creditStatus == 0 ? id : 0) });
            this.state.creditStatus = (this.state.creditStatus == 0 ? id : 0);
        }
        else if (id == 2) {
            this.setState({ creditStatus1: (this.state.creditStatus1 == 0 ? id : 0) });
            this.state.creditStatus1 = (this.state.creditStatus1 == 0 ? id : 0);
        }
        else if (id == 3) {
            this.setState({ creditStatus2: (this.state.creditStatus2 == 0 ? id : 0) });
            this.state.creditStatus2 = (this.state.creditStatus2 == 0 ? id : 0);
        }
        else if (id == 4) {
            this.setState({ creditStatus3: (this.state.creditStatus3 == 0 ? id : 0) });
            this.state.creditStatus3 = (this.state.creditStatus3 == 0 ? id : 0);
        }
        else if (id == 5) {
            this.setState({ creditStatus4: (this.state.creditStatus4 == 0 ? id : 0) });
            this.state.creditStatus4 = (this.state.creditStatus4 == 0 ? id : 0);
        }
        else if (id == 6) {
            this.setState({ creditStatus5: (this.state.creditStatus5 == 0 ? id : 0) });
            this.state.creditStatus5 = (this.state.creditStatus5 == 0 ? id : 0);
        }
        if ((this.state.creditStatus == 0 && this.state.creditStatus1 == 0 && this.state.creditStatus2 == 0 && this.state.creditStatus3 == 0 && this.state.creditStatus4 == 0 && this.state.creditStatus5 == 0) || (this.state.creditStatus != 0 && this.state.creditStatus1 != 0 && this.state.creditStatus2 != 0 && this.state.creditStatus3 != 0 && this.state.creditStatus4 != 0 && this.state.creditStatus5 != 0)) {
            this.setState({ allStatus: 0 });
        }
        else {
            this.setState({ allStatus: 1 });
        }
    }

    render() {
        const { t } = this.props;
        return (
            <>
                {
                    process.env.REACT_APP_MODE != "development" && <Helmet>
                        <title>Gulf Ticket : MyFavourite</title>
                        <meta name="description" content="Gulf Ticket MyFavourite" />
                    </Helmet>
                }
                {/* <div className="divBorder">
                                    <div className="accHeadCont favouriteFiltersAlign">
                                        <div className="radioInputs">
                                            <div className="filterBlock">{t('lblFilterBy')}:</div>
                                            <div className="checkbox-container" >
                                                <input checked={this.state.creditStatus3 == 4} onClick={() => { this.chkbtnClick(4) }} id="r4" type="checkbox" name="group1" className="custom-checkbox" />
                                                <label for="r4" className="font18"></label>
                                                <span className="" onClick={() => { this.chkbtnClick(4) }}> <img src="./assets/img/gamesBg/lucky-1-logo.png" alt="super 5 logo" className="h-8 w-20" /> </span>
                                            </div>
                                            <div className="checkbox-container" >
                                                <input checked={this.state.creditStatus5 == 6} onClick={() => { this.chkbtnClick(6) }} id="r6" type="checkbox" name="group1" className="custom-checkbox" />
                                                <label for="r6" className="font18"></label>
                                                <span className="" onClick={() => { this.chkbtnClick(6) }}> <img src="./assets/img/gamesBg/pick-3-logo.png?v0.3" alt="Pick 3 logo" className="h-8 w-20" /> </span>
                                            </div>
                                            <div className="checkbox-container">
                                                <input checked={this.state.creditStatus2 == 3} onClick={() => { this.chkbtnClick(3) }} id="r3" type="checkbox" name="group1" className="custom-checkbox" />
                                                <label for="r3" className="font18"></label>
                                                <span className="" onClick={() => { this.chkbtnClick(3) }}> <img src="./assets/img/gamesBg/magic-5-logo.png?v0.2" alt="magic 5 logo" className="h-8 w-20" /> </span>
                                            </div>
                                            <div className="checkbox-container" >
                                                <input checked={this.state.creditStatus == 1} onClick={() => { this.chkbtnClick(1) }} id="r1" type="checkbox" name="group1" className="custom-checkbox" />
                                                <label for="r1" className="font18"></label>
                                                <span className="" onClick={() => { this.chkbtnClick(1) }}> <img src="./assets/img/gamesBg/fortune-6-logo.png?v0.2" alt="fortune-4 logo" className="h-8 w-20" /> </span>
                                            </div>
                                            <div className="checkbox-container" >
                                                <input checked={this.state.creditStatus1 == 2} onClick={() => { this.chkbtnClick(2) }} id="r2" type="checkbox" name="group1" className="custom-checkbox" />
                                                <label for="r2" className="font18"></label>
                                                <span className="" onClick={() => { this.chkbtnClick(2) }}> <img src="./assets/img/gamesBg/super-6-logo.png?v0.2" alt="super 5 logo" className="h-8 w-20" /> </span>
                                            </div>

                                            <div className="checkbox-container" >
                                                <input checked={this.state.creditStatus4 == 5} onClick={() => { this.chkbtnClick(5) }} id="r5" type="checkbox" name="group1" className="custom-checkbox" />
                                                <label for="r5" className="font18"></label>
                                                <span className="" onClick={() => { this.chkbtnClick(5) }}> <img style={{ marginTop: '-13px' }} src="./assets/img/gamesBg/dream-5-logo.png?v0.1" alt="dream5 5 logo" className="h-8 w-20" /> </span>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                <div class="myAccContHead">
                    <h1><img src="./assets/img/icons/tabs-favourites.png" /> {t('lblFav')}</h1>
                </div>
                {this.state.FavNo && this.state.FavNo.length > 0 ?
                    <div class="favourites">
                        <div class="latestDrawRslt padding-bottom-0">
                            <ul>
                                <li>
                                    <div class="w-20 head"> {t('lbllotto')}</div>
                                    <div class="w-20 head">{t('lbldate')}</div>
                                    <div class="w-50 head">{t('lblTicket')}</div>
                                </li>
                                {this.state.FavNo && this.state.FavNo.filter(fdata => this.state.allStatus == 0 || fdata.game_group_id == this.state.creditStatus || fdata.game_group_id == this.state.creditStatus1 || fdata.game_group_id == this.state.creditStatus2 || fdata.game_group_id == this.state.creditStatus3 || fdata.game_group_id == this.state.creditStatus4
                                    || fdata.game_group_id == this.state.creditStatus5).map((x, index) =>
                                        <li key={`bh_${index}`} className="lto-1">
                                            <div class={`w-20 gameName lto-${x.game_group_id}-text-color`}>{x.game_name}</div>
                                            <div class="w-20 date">{x.date}</div>
                                            <div class="w-40">
                                                {x.numbers.split(';').map((No, inx) =>
                                                    <div key={`bj_${inx}`} class={`lottoRsltBalls lto-${x.game_group_id}-bg-color`}>{No}</div>
                                                )}
                                            </div>
                                            <div class="w-20 winBtn">
                                                <button onClick={() => { this.DeletefavNo(x.favorite_id, x) }}><img src="./assets/img/icons/cancel.png" /></button>
                                                <a onClick={() => this.PlayAgain(x.numbers, x.game_group_id)}>{t('lblBuyAgain')}</a>
                                            </div>
                                        </li>
                                    )}
                            </ul>
                        </div>
                    </div>
                    :
                    <div class="noOrders">
                        <img src="./assets/img/icons/sad.png" />
                        <h3>{t("lblNoFavourites")}</h3>
                        <p class="margin-bottom-20">{t("lbladdthings")}</p>
                        <div class="formCont updateBtn">
                            <button onClick={() => {history.push('/playlotto')}}>{t("lblAddNow")}</button>
                        </div>
                    </div>
                }
            </>
        );
    }
}
function mapStateToProps(state) {
    const { user } = state.loginReducer;
    const { FavNo, ObjDeleteFavNo } = state.gameReducer;
    return { user, FavNo, ObjDeleteFavNo };
}
const mapActionToProps = {
    alertError: alertActions.error,
    changepassword: loginActions.changepassword,
    GetfavNo: gameActions.GetfavNo,
    BackFromCart: gameActions.BackFromCart,
    DeletefavNo: gameActions.DeletefavNo
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(MyFavouriteNew))